import { useEffect } from "react";
import { OutputImage } from "./types";
import { useImageProcessing } from "./useImageProcessing";
import { getOutputImageSide } from "../../common/slices/specsEditor/reducers/images";

export function EagerProcessor({
  outputImage,
  inputLayers,
  onProcessed,
  side,
}: {
  outputImage: OutputImage;
  inputLayers: { id: string; name: string; imageDataUrl: string }[];
  onProcessed: (imageId: string, url: string, side?: string) => void;
  side: string;
}) {
  const sideState = getOutputImageSide(outputImage, side);
  const sourceLayer = inputLayers.find(
    (layer) => layer.id === sideState?.sourceLayerId
  );
  const baseImageUrl =
    sideState?.aiTransform?.acceptedImageUrl ??
    sourceLayer?.imageDataUrl ??
    null;
  const processedUrl = useImageProcessing(
    baseImageUrl,
    sideState?.transformations ?? []
  );

  useEffect(() => {
    if (processedUrl) {
      onProcessed(outputImage.id, processedUrl, side);
    }
  }, [onProcessed, outputImage.id, processedUrl, side]);

  return null;
}
